export const CONSTANTS = Object.freeze({
  TIPO_OPERACION: {
    SANDCUBES: {
      ID: 1,
      DESCRIPCION: "Operación a Sandcubes",
    },
    A_GRANEL: {
      ID: 2,
      DESCRIPCION: "Operación a Granel",
    },
    MIXTA: {
      ID: 3,
      DESCRIPCION: "Operación Mixta",
    },
  },
  MAGNITUDES: {
    LIBRAS: "lbs",
    TONELADAS: "tons",
  },
});
